import {
  OIDC_META_TAG_API_PROXY_PATH,
  OIDC_META_TAG_ENABLED,
  OIDC_META_TAG_RESOURCE_INDICATOR,
} from '@issuemanager/infrastructure/constructs/oidc/constants';

export type OidcSidecarConfig = {
  readonly resourceIndicator: string;
  readonly apiProxyPath: string;
};

const readMetaContent = (name: string): string | undefined =>
  document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content;

const matchesHost = (hostname: string, rootDomain: string): boolean =>
  hostname === rootDomain || hostname.endsWith(`.${rootDomain}`);

const readResourceIndicatorForHost = (hostname: string): string | undefined => {
  const tags = document.querySelectorAll<HTMLMetaElement>(
    `meta[name="${OIDC_META_TAG_RESOURCE_INDICATOR}"]`,
  );
  for (const tag of Array.from(tags)) {
    const { rootDomain } = tag.dataset;
    if (rootDomain && matchesHost(hostname, rootDomain)) {
      return tag.content;
    }
  }
  return undefined;
};

export const readSidecarConfig = (): OidcSidecarConfig | null => {
  const enabled = readMetaContent(OIDC_META_TAG_ENABLED) === 'true';
  const resourceIndicator = readResourceIndicatorForHost(
    window.location.hostname,
  );
  const apiProxyPath = readMetaContent(OIDC_META_TAG_API_PROXY_PATH);

  if (!enabled || !resourceIndicator || !apiProxyPath) {
    return null;
  }

  return { resourceIndicator, apiProxyPath };
};
